import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileOrderBar from "./MobileOrderBar";
import CookieConsent from "./CookieConsent";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="relative min-h-screen flex flex-col bg-[#F7F5F0] text-[#1A1A1A]">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[80] focus:top-3 focus:left-3 focus:bg-[#1A1A1A] focus:text-white focus:px-4 focus:py-2 focus:rounded-full">Skip to content</a>
      <Header />
      <main id="main-content" className="relative z-10 flex-1 pt-24 md:pt-28">
        <Outlet />
      </main>
      <Footer />
      <MobileOrderBar />
      <CookieConsent />
    </div>
  );
}
